import { render, staticRenderFns } from "./dialog_userMsg.vue?vue&type=template&id=2dc542cb&scoped=true&"
import script from "./dialog_userMsg.vue?vue&type=script&lang=js&"
export * from "./dialog_userMsg.vue?vue&type=script&lang=js&"
import style0 from "./dialog_userMsg.vue?vue&type=style&index=0&id=2dc542cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc542cb",
  null
  
)

export default component.exports